module.exports = __webpack_public_path__ + "img/drag-and-drop.2de56fdb.svg";